<template>
  <div class="content">
      <!-- 头部 -->
      <div class="content-top">
          <img src="../../assets/img/template@2x(1).png" style="width: 170px"/>
      </div>
      <!-- 主要内容 -->
      <div class="main">
                <div class="main-login">
                    <div>
                        <h3 style="font-weight: 800;margin-bottom:20px;font-size: 18px;">Hi,Welcome Back!</h3>
                        <p style="color:#4e4646;margin-bottom:25px">Log in to your account</p>
                    </div>
                    <el-form  :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
                        <el-form-item  prop="role">
                            <el-select class="unit" v-model="ruleForm.role" placeholder="请选择登录角色" @change="roleChange">
                            <el-option label="机构账号" value="org"></el-option>
                            <el-option label="个人账号" value="user"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  prop="username">
                            <el-input v-model="ruleForm.username" @keyup.enter.native="submitForm('ruleForm')" prefix-icon="el-icon-user"></el-input>
                        </el-form-item>
                        <el-form-item  prop="password">
                        
                            <el-input show-password placeholder="请输入密码" v-model="ruleForm.password"  style="width:60%" @keyup.enter.native="submitForm('ruleForm')" ></el-input>
                        </el-form-item>
                        <el-form-item style="text-align:center;">
                            <el-checkbox v-model="checked">记住密码</el-checkbox>
                        </el-form-item>
                        <el-form-item>
                            <el-button  @click="submitForm('ruleForm')">登录</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="main-r">
                    <!-- 小人 -->
                    <div class="top-img">
                    </div>
                    <div class="bj-txt">
                        <h2 style="text-align: center;margin:15px 0px">登录您的 Scholarcy 账户</h2>
                        <p style="margin:0px 50px;color:rgb(108 102 102);line-height:22px"> 智能高校的阅读工具Scholarcy运用Robot-Highlighter  <span style="font-size:8px;vertical-align:text-bottom;">TM</span> 技术，
                            将文献内容进行要点提炼并同步翻译成中文；提炼要点全面包括摘要、关键点、概要、简介、研究方法、
                            研究结果、讨论、相关工作、总结、基金、参与人员与数据统计、参考文献、笔记备注等内容。您的文档可在任何设备上访问。 
                            从 PDF 文件创建摘要卡，并导出到 Word ！</p>
                    </div>
                </div>
      </div>
      <!-- 底部备案信息 -->
      <div class="content-footer">
            <ul class="left">
                <li>北京盈科千信科技有限公司</li>
                <li>地址： 北京市海淀区中关村南大街48号</li>
                </ul>
                <ul class="right">
                <li>邮箱： product@increscence.net</li>
                <li>
                    Copyright © 2022 <img style="width:20px;margin-bottom: -5px;" src="../../assets/img/footerp.png" alt=""> 京ICP备15054044号-1
                </li>
            </ul>
      </div>
  </div>
</template>

<script>
export default {
    name:'login',
    data(){
        return{
            ruleForm:{
                username:"", // 用户名
                password:"", // 密码
            },
            // 表单验证
            rules: {
                username: [
                    { required: true, message: '账号必填', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '密码必填', trigger: 'blur' },
                ],
                role:[
                    { required: true, message: '请选择登录角色', trigger: 'change' },
                ]
            },
            value:"first",// 默认 tabs显示第一个
            formValue:"",
            checked:false
        }
    },
    created(){
        if(window.localStorage.getItem('user_pass')){
            var users = JSON.parse(decodeURI(window.localStorage.getItem('user_pass')))
            this.ruleForm.username = users.username
            this.ruleForm.password = users.password
            this.ruleForm.role = users.formValue
            this.formValue = users.formValue
            this.checked = true
        }
    },
    watch: {
        
    },
    methods: {
        // 选择的登录角色
        roleChange(value){
            this.formValue = value
        },
        // 登陆
        submitForm(formName) {
        // 验证
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.formValue == "org"){
                // 机构账号登录
                this.$http({
                    url:"api/org_login/",
                    method:'POST',
                    data:{
                        username:this.ruleForm.username,
                        password:this.ruleForm.password,
                    }
                }).then(res=>{
                    console.log(res)
                    if(res.data.code == 200){
                        window.localStorage.setItem("token",JSON.stringify(res.data.token));
                        window.localStorage.setItem("role","机构");
                        window.localStorage.setItem("organ_name",res.data.organ_name);
                        if(this.checked == true){
                            window.localStorage.setItem("user_pass", encodeURI(JSON.stringify({username:this.ruleForm.username,password:this.ruleForm.password,formValue:'org'})));
                        }else{
                            window.localStorage.setItem("user_pass", '');
                        }
                        this.$message.success(res.data.message);
                        this.$router.push({
                        name: "org",
                    });
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }else if(this.formValue == "user"){
                // 子账号登录
                 this.$http({
                    url:"api/user_login/",
                    method:'POST',
                    data:{
                        username:this.ruleForm.username,
                        password:this.ruleForm.password
                    }
                }).then(res=>{
                    console.log(res)
                    if(res.data.code == 200){
                        
                        // 成功
                        window.localStorage.setItem("token",JSON.stringify(res.data.token));
                        window.localStorage.setItem("role","个人");
                        window.localStorage.setItem("organ_name",res.data.organ_name);
                        window.localStorage.setItem("user_name",res.data.user_name)
                        if(this.checked == true){
                            window.localStorage.setItem("user_pass", encodeURI(JSON.stringify({username:this.ruleForm.username,password:this.ruleForm.password,formValue:'user'})));
                        }else{
                            window.localStorage.setItem("user_pass", '');
                        }
                        this.$message.success(res.data.message);
                        this.$router.push({
                        name: "home",
                    });
                    }else{
                        // 失败
                        this.$message.error(res.data.message);
                    }
                })
            }
          } else {
            // 失败
            return false;
          }
        });
      },
        
    },

}
</script>

<style lang="scss" scoped>
.content{
    // 头部 81
    .content-top{
        // #b0b0b0 #BBBFC4
        border-bottom: 1px solid #eeeeee;
        padding: 10px 0px 10px 100px;
    }
    // 主要内容  -172
    .main{
        min-height: calc(100vh - 165px);
        display: flex;
        justify-content: space-around;
        align-items: center;
        // 登录表单
        .main-login{
            width: 50%;
            padding: 0px 0px 0px 250px;
        }
        // 小人--信息  
        .main-r{
            width:50%;
            .top-img{
                margin: 0px 10%;
                background: 
                url('../../assets/img/3.png') 0px 70px no-repeat,
                url('../../assets/img/illustration (2).png') -50px 0px no-repeat,;
                background-size: 100%;
                height: 580px;
            }
        }
    }
    // 底部备案信息 91
    .content-footer{
        border-top: 1px solid #eeeeee;
        text-align: center;
        padding: 15px 0px;
        line-height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        .left {
            width: 250px;
            margin-right: 30px;
            text-align: left;
            color: #b0b0b0;
            list-style: none;
        }
        .right{
            text-align: left;
            border-left: 2px solid #b0b0b0;
            padding-left: 30px;
            color: #b0b0b0;
            list-style: none;
        }
    }


}













::v-deep .el-input--suffix .el-input__inner {
    padding-right: 30px;
    border-radius: 8px;
    height: 45px;
}
.unit ::v-deep .el-input__inner{
    background: url("../../assets/img/服务类型.png") no-repeat;
    background-size: 16px 14px;
    background-position: 10px center;
    padding: 0 30px 0 36px;
    box-sizing: border-box;
    font-size: 14px;
}
::v-deep .el-input__inner:focus{
    border: 2px solid #B095ED;
    border-color:#B095ED
}
::v-deep .el-select .el-input.is-focus .el-input__inner {
    border-color: #B095ED;
    border: 2px solid #B095ED;
} 
::v-deep .el-button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #FFF;
    border: 1px solid #B095ED;
    /* color: #606266; */
    background-color: #B095ED;
    color: white;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 8px;
    width: 60%;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
    color:#B095ED;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #B095ED !important;
    border-color: #B095ED !important;

}
.el-select {
    display: inline-block;
    position: relative;
    width: 60%;
}
::v-deep .el-input--prefix .el-input__inner {
    padding-left: 30px;
    width: 60%;
    border-radius: 8px;
    height: 45px;
}
// 登录表单
.left-form{
    width:calc(100% - 600px);
    position:relative;
    float: left;
}
// 登录背景图
.bj-login{
    position:relative;
    margin-left: calc(100% - 600px);
    width: 600px;
    // 登录背景图
    .bj-top{
    background: url('../../assets/img/3.png') 0px 41px no-repeat,
                url('../../assets/img/1.png') -27px -72px no-repeat, 
                url('../../assets/img/2.png') 83px 119px no-repeat;
    background-size: 100% 100%;
    height: 450px;
}
    // 登录 文字
    .bj-txt{
        position:absolute;
        h2{
            text-align:center;
        }
        p{
            padding:15px;
        }
        
    }
}
.login{
    width: 100%;
    padding: 2% 10% 2% 15%;
    // background-image: url('../../assets/img/login.png');
    // background-size: 100% 100%;
    // min-width: 1200px;
    min-height: 100vh;
    // padding: 0px 50px 0px 0px;
    .nav{
        // position: absolute;top: 270px;margin-top: -50px;margin-left:20%;
    }
}
.demo-select-base {
  width: 300px;
}
@media screen and (max-width: 1600px){
    .main-login{
            width: 40%;
            padding: 0px 0px 0px 250px;
        }
        // 小人--信息  
        .main-r{
            width:60%;
        }
        .bj-txt{
        p{
            padding:5px;
            font-size: 12px;
        }
        
    }
    .content .main .main-r .top-img{
        margin: 0px 10%;
        background: 
        url('../../assets/img/3.png') 0px 70px no-repeat,
        url('../../assets/img/illustration (2).png') -50px 0px no-repeat,;
        background-size: 100%;
        height: 450px;
    }
}
</style>